import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  Button,
  message,
  Row,
  Col,
  Card,
  Modal,
} from "antd";
import paypal from "../../../assets/images/paypal.svg";
import stripe from "../../../assets/images/stripe.svg";
import square from "../../../assets/images/square.svg";
import "./Payment.scss";
import { useSelector } from "react-redux";
import PaymentService from "../../../services/PaymentService";
import LinkPaymentModal from "./LinkPaymentModal";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import ConfigureTerminals from "./ConfigureTerminals";

const { Content } = Layout;
const { confirm } = Modal;

const Payment = () => {
  const [paymentList, setPaymentsList] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedTab, setSelectedTab] = useState("Online Sales");
  const [updatedLink, setUpdatedLink] = useState();
  const [isEdit, setEdit] = useState(false);
  const [view, setView] = useState("payment");

  const adminRestaurant = useSelector((state) => state.admin);

  const payment = [
    {
      id: 1,
      icon: paypal,
      isLinked: false,
      provider: "PAYPAL",
    },
    {
      id: 1,
      icon: stripe,
      isLinked: false,
      provider: "STRIPE",
    },
    {
      id: 3,
      icon: square,
      provider: "SQUARE",
    },
  ];

  const TerminalandCardReader = [
    {
      id: 1,
      icon: square,
      provider: "SQUARE",
    },
  ];

  const [terminalCardReader,setTerminalCardReader] = useState(TerminalandCardReader)
  useEffect(() => {
    getProviders();
  }, [adminRestaurant]);

  const getProviders = async (id) => {
    const dataList = await PaymentService.getProviders(adminRestaurant);

    const paymentProviders = payment.map((item) => {
      const obj = {
        ...item,
        id: dataList?.find((e) => e.provider === item.provider)?.id,
        isLinked: dataList?.some((e) => e.provider === item.provider),
        client_id: dataList?.find((e) => e.provider === item.provider)
          ?.client_id,
      };
      return obj;
    });
    setPaymentsList(paymentProviders);
    setTerminalCardReader(TerminalandCardReader.map(item => (
      {
      ...item,
      id: dataList?.find((e) => e.provider === item.provider)?.id
      }
    )))
  };

  const closeModal = (status) => {
    setAddModal(status);
    getProviders();
  };
  const editSettings = (record) => {
    setUpdatedLink(record);
    setSelectedProvider(record.provider);
    setEdit(true);
    setAddModal(true);
  };

  const deleteProvider = async (record) => {
    await PaymentService.deleteProviders(record.id);
    message.success("Deleted successfully");
    getProviders();
  };

  const handleDelete = (record) => {
    confirm({
      title: "Are you sure to delete?",
      icon: <ExclamationCircleOutlined />,
      content: " This action cannot be undone.",

      onOk() {
        deleteProvider(record);
      },

      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const linkAccount = (item) => {
    setSelectedProvider(item.provider);
    setEdit(false);
    setAddModal(true);
  };

  const addProvider = async (item) => {
    const providers = paymentList.map((items) => {
      if (selectedProvider == items.provider) {
        const obj = {
          name: selectedProvider,
          client_secret: item.client_secret,
          client_id: item.client_id,
        };
        return obj;
      } else return undefined;
    });

    const payload = {
      restaurant_id: adminRestaurant,
      providers: providers.filter((item) => item && item.name),
    };
    await PaymentService.linkProviders(payload);
    message.success("Linked payment provider successfully");
    getProviders();
  };

  const updateProvider = async (record) => {
    const id = paymentList.find((e) => e.provider === selectedProvider)?.id;
    const payload = {
      client_id: record.client_id,
      client_secret: record.client_secret,
    };
    await PaymentService.updateProviders(payload, id);
    message.success("Updated successfully");
    getProviders();
  };

  return (
    <>
      {view === "payment" && (
        <Layout className="u-page-layout">
          <Content className="page-padding">
            <Space className="w-full" direction="vertical">
              <PageHeader
                title={"Online Payments"}
                style={{ minHeight: 80 }}
                className="d-flex items-center page-header-business"
                extra={[
                  <div className="button-div">
                    <Button
                      className={
                        selectedTab === "Online Sales"
                          ? "selected-tab-button custom-btn"
                          : "button-grp-border default-button custom-btn"
                      }
                      type="primary"
                      onClick={() => {
                        setSelectedTab("Online Sales");
                      }}
                    >
                      Online Sales
                    </Button>
                    <Button
                      className={
                        selectedTab === "POS"
                          ? "selected-tab-button custom-btn"
                          : "button-grp-border default-button custom-btn"
                      }
                      type="primary"
                      onClick={() => {
                        setSelectedTab("POS");
                      }}
                    >
                      POS
                    </Button>
                  </div>,
                ]}
              />
              <div className="content-container-business ">
                <Row className="space-between">
                  {paymentList.map((item) => (
                    <Col key={item.id} className="payment-col">
                      <Card className="payment-card">
                        <img
                          src={item.icon}
                          alt="check"
                          className="payment-icon"
                        />

                        <div className="card-footer">
                          {item.isLinked ? (
                            <>
                              <div
                                className="remove-btn"
                                onClick={() => handleDelete(item)}
                              >
                                Remove Payment Methods
                              </div>
                              <div
                                className="edit-btn"
                                onClick={() => editSettings(item)}
                              >
                                Edit Settings
                              </div>
                            </>
                          ) : (
                            <Button
                              className="link-btn"
                              onClick={() => linkAccount(item)}
                            >
                              Link Account
                            </Button>
                          )}
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
              {selectedTab === "POS" && (
                <>
                  <PageHeader
                    title={"Terminal and Card Readers"}
                    style={{ minHeight: 80 }}
                    className="d-flex items-center"
                  />
                  <div className="content-container ">
                    <Row className="space-between">
                      {TerminalandCardReader.map((item) => (
                        <Col key={item.id} className="payment-col">
                          <Card className="payment-card">
                            <img
                              src={item.icon}
                              alt="check"
                              className="payment-icon"
                            />
                            <div className="card-footer">
                              <Button
                                className="link-btn"
                                onClick={() => setView("configureTerminals")}
                              >
                                Configure Terminal/Card Reader
                              </Button>
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </>
              )}
            </Space>
          </Content>

          {addModal && (
            <LinkPaymentModal
              modalOpen={true}
              isEdit={isEdit}
              closeModal={closeModal}
              updatedLink={updatedLink}
              addProvider={addProvider}
              updateProvider={updateProvider}

            />
          )}
        </Layout>
      )}
      {view === "configureTerminals" && (
        <ConfigureTerminals setView={setView}
        terminalCardReader={terminalCardReader} />
      )}
    </>
  );
};

export default Payment;
